(function () {
  if (window.NutraChampsSwymCardNotifyInitialized) return;
  window.NutraChampsSwymCardNotifyInitialized = true;

  var swym = window._swat || null;
  var pendingButton = null;

  function productFromButton(button) {
    return {
      empi: Number(button.dataset.productId),
      epi: Number(button.dataset.variantId),
      du: button.dataset.productUrl,
      pr: Number(button.dataset.productPrice),
      iu: button.dataset.productImage,
      et: 8
    };
  }

  function openNotifyForm(button) {
    if (!swym || typeof swym.addToWatchList !== 'function') return;

    var swymEvent = {
      target: button,
      currentTarget: button,
      preventDefault: function () {},
      stopPropagation: function () {}
    };

    button.setAttribute('aria-busy', 'true');
    swym.addToWatchList(swymEvent, productFromButton(button), function () {
      button.removeAttribute('aria-busy');
    });

    window.setTimeout(function () {
      button.removeAttribute('aria-busy');
    }, 1000);
  }

  function onSwymReady(instance) {
    swym = instance;
    if (pendingButton) {
      openNotifyForm(pendingButton);
      pendingButton = null;
    }
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(onSwymReady);

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest
      ? event.target.closest('.swym-card-notify')
      : null;

    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!swym && window._swat) swym = window._swat;
    if (swym) {
      openNotifyForm(button);
      return;
    }

    pendingButton = button;
    button.setAttribute('aria-busy', 'true');
  }, true);
})();
